import axios from 'axios';
import { debounce } from 'lodash';
import React, { useEffect, useState } from 'react'
import { useCallback, useMemo } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Form } from 'reactstrap'
import EmptyTable from '../../../components/errorComponents/EmptyTable';
import BuildingModal from '../../../components/Modal/BuildingModal';
import SuccessPopups from '../../../components/Popups/SuccessPopups';
import WarningPopup from '../../../components/Popups/WarningPopup';
import Table from '../../../components/Table'
import { environment } from '../../../env';
import AsyncSelect from 'react-select/async';
import { getGalaAction, getProjectAction, getSoldGalaAction, loaderAction, warningModalToggle, successModalToggle } from '../../../redux/actions/Index';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import _ from "lodash";
import { getBuildingAction } from './../../../redux/actions/Index';
import { Eye, Trash } from '@phosphor-icons/react';
import PathName from '../../../components/PathName/PathName';

const Building = (props) => {
    const [filteredBuilding, setFilteredBuilding] = useState()
    const [filterBuilding, setFilterBuilding] = useState([]);
    const user = useSelector((state) => state?.Reducers?.userdata);
    const buildingList = useSelector((state) => state?.ModalReducer?.buildingList);
    const userProject = useSelector((state) => state?.ModalReducer?.userproject);
    const dispatch = useDispatch()
    const {
        register,
        handleSubmit,
        watch,
        control,
        formState: { errors },
    } = useForm();

    var selectedProject = watch('project');
    var selectedBuilding = watch('building');

    const debounce = useCallback(
        _.debounce((_searchVal) => {
            Search(_searchVal);
        }, 500)
    )
    const onSubmit = (data) => {
        debounce(data)
    }

    const Search = (query) => {
        dispatch(loaderAction())
        const SearchUrl = `${environment.baseUrl}building-filter/?search=${query}`;
        const result = axios(SearchUrl).then((res) => {
            if (res?.data?.length > 0) {
                setFilteredBuilding(res.data);
                dispatch(loaderAction())

            } else {
                toast.info(`Building not found !`, {
                    position: toast.POSITION.TOP_CENTER
                });
                dispatch(loaderAction())
            }

        })
    }

    const getBuildingData = () => {
        try {
            axios.get(`${environment.baseUrl}building/`).then(res => {
                dispatch(getBuildingAction(res.data));

            }).catch(res => {
                console.log("error");
            })
        }
        catch (err) {
            console.log(err);
        }
    };

    const getGalaData = () => {
        try {
            axios.get(`${environment.baseUrl}gala/`).then(res => {
                let data = res.data.filter((data, i) => data?.project.id == userProject)
                dispatch(getGalaAction(data));
            }).catch(res => {
                console.log("error");
            })
        }
        catch (err) {
            console.log(err);
        }
    };
    const getSoldGalaData = () => {
        try {
            axios.get(`${environment.baseUrl}sold-gala/`).then(res => {
                let data = res.data.filter((data, i) => data?.project.id == userProject)
                dispatch(getSoldGalaAction(data));
            }).catch(res => {
                console.log("error");
            })
        }
        catch (err) {
            console.log(err);
        }
    };

    const getProjectData = () => {
        try {
            axios.get(`${environment.baseUrl}project/`).then(res => {
                let data = res.data;
                dispatch(getProjectAction(data));

            }).catch(res => {
                console.log("error");
            })
        }
        catch (err) {
            console.log(err);
        }
    };

    const deleteBuildingData = (id) => {
        dispatch(warningModalToggle(id));

    };

    const deleteData = (id) => {
        dispatch(loaderAction())
        dispatch(warningModalToggle(id))
        axios.delete(`${environment.baseUrl}editbuilding/${id}`).then(res => {
            if (res.data.code === 200) {
                getBuildingData()
                getGalaData()
                getSoldGalaData()
                getProjectData()
                dispatch(successModalToggle());
                dispatch(loaderAction())
            } else if (res.data.code === 5005) {
                dispatch(loaderAction());
                toast.error(res.data.message, {
                    position: toast.POSITION.TOP_CENTER
                });
              }
        })
            .catch(res => {
                dispatch(loaderAction())
                console.log("error");
            })
    };

    const columns = [
        {
            name: 'Building No',
            selector: row => row.building_no,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Area Builtup',
            selector: row => row.area_builtup + " " + "Sq.ft",
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'No. of Gala',
            selector: row => row.no_of_gala,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Galas Created',
            selector: row => row.gala_created,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Sold Space',
            selector: row => (row.sold_area) + " " + "Sq.ft",
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Remaining Space',
            selector: row => (row.area_builtup - row.sold_area).toFixed(2) + " " + "Sq.ft",
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Action',
            cell: (row) => <div className="d-flex justify-content-between align-items-center gap-2 ">
                <Link to={`/Buildings/${row.id}`} data={row} className="icon-bg-green border-0 px-2 py-3 rounded"><Eye size="28" className='icon-color-green' /></Link>
                {user?.role != 'user' && <>
                    <BuildingModal button='edit' title='Edit New Projects' data={row} />
                    {user?.role == 'superadmin' && <button onClick={() => deleteBuildingData(row.id)} id={row.ID} className="icon-bg-red border-0 px-2 py-3 rounded"><Trash size="28" className='icon-color-red' /></button>}
                </>}
            </div>,
        },
    ];


    useEffect(() => {
        let buildinglist = [];
        let buildinglistt = [];
        if (userProject) {
            var projectBuilding = buildingList?.filter((filterBuilding) => filterBuilding.project.id == userProject);
            projectBuilding?.map((building) => {
                buildinglist.push({ label: building.building_no, value: Number(building.id) })
                buildinglistt.push(building)
            })
            const sortedOptions = buildinglist?.sort((a, b) => (a.label > b.label ? 1 : -1));
            setFilterBuilding(sortedOptions)
            setFilteredBuilding(buildinglistt)
        }
    }, [userProject, buildingList])

    useMemo(() => {
        let buildinglisttt = [];
        buildingList?.filter((filterBuilding) => { if (filterBuilding?.id == selectedBuilding?.value) { buildinglisttt.push(filterBuilding) } })
        setFilteredBuilding(buildinglisttt)

    }, [selectedBuilding?.value])

    const ProjectOptions = async (query) => {
        let filteredProjects;
        const filteredProjectURL = `${environment.baseUrl}filter-project/`;
        const FilterProjectPayload = new FormData();
        FilterProjectPayload.append('query', query);
        const result = await axios.post(filteredProjectURL, FilterProjectPayload).then((response) => {
            let filteredProject = [];
            response.data.map((projectList) => {
                filteredProject.push({ label: projectList.name, value: projectList.id })
            })
            filteredProjects = filteredProject;
        })
        if (filteredProjects.length > 0) {
            return filteredProjects
        } else {
            return []
        }
    };

    const BuildingOptions = async (query) => {
        let filteredBuildings;
        const filteredBuildingURL = `${environment.baseUrl}filter-building/`;
        const FilterBuildingPayload = new FormData();
        FilterBuildingPayload.append('query', query);

        const result = await axios.post(filteredBuildingURL, FilterBuildingPayload).then((response) => {
            let filteredBuilding = [];
            response.data.map((BuildingList) => {
                filteredBuilding.push({ label: BuildingList.building_no, value: BuildingList.id })
            })
            filteredBuildings = filteredBuilding;
        })

        if (filteredBuildings.length > 0) {
            return filteredBuildings
        } else {
            return []
        }
    };

    useEffect(() => {
        console.log("Building Refresh")
    }, [buildingList])

    return (
        <>
            <SuccessPopups />
            <WarningPopup deleteData={deleteData} />
            <PathName />
            <div className="Building-main">
                <Form >
                    <div className='my-4 row'>
                        <div className='col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1'>
                            <div className='mt-1  d-flex gap-3'>
                                <Controller
                                    control={control}
                                    name="building"
                                    rules={{ required: true }}
                                    render={({
                                        field: { onChange },
                                        fieldState: { isTouched, isDirty, error },
                                        formState,
                                    }) => (
                                        <AsyncSelect placeholder="Search Building" cacheOptions defaultOptions={filterBuilding} loadOptions={BuildingOptions} className='w-100' onChange={onChange} />
                                    )}
                                />
                            </div>
                            <br />
                        </div>
                    </div>
                </Form>
                <div className="bg-white rounded-5 mb-5 shadow-sm  p-4 p-md-4 p-lg-5 p-xl-5">
                    <div >
                        <div className="d-flex justify-content-between align-items-center">
                            <h1 className='mb-5 title-font-bold '>BUILDING</h1>
                            <BuildingModal button='create' data={buildingList} />
                        </div>
                        {userProject == undefined || filterBuilding?.length == 0 || buildingList?.[0] === undefined ? <EmptyTable /> : <Table columns={columns} data={filteredBuilding} />}
                    </div>
                </div>
            </div>

        </>
    )
}

export default Building